module.exports = __webpack_public_path__ + "assets/media/evening.2194994b.mp3";